<template>
  <button
    type="button"
    class="flex w-full items-start gap-5 border-b border-[#ebedef] px-2.5 py-[18px] text-left"
    @click="$emit('select')"
  >
    <div class="size-[68px] shrink-0">
      <Thumbnail
        :type="fileThumbType(file)"
        :src="fileThumbSrc(file) ?? undefined"
      />
    </div>
    <div class="min-w-0 flex-1">
      <div
        class="mb-3 line-clamp-2 text-[15px] font-medium leading-5 text-gray-800"
      >
        {{ file.name }}
      </div>
      <div class="space-y-[3px] text-[13px] leading-[18px]">
        <div class="flex">
          <span class="w-[90px] shrink-0 text-gray-500">Owner</span>
          <span class="min-w-0 flex-1 truncate text-gray-800">
            {{ file.owner.name }}
          </span>
        </div>
        <div class="flex">
          <span class="w-[90px] shrink-0 text-gray-500">Timestamp</span>
          <span class="flex min-w-0 flex-1 items-center gap-1.5 text-gray-800">
            <DacrMarkIcon class="size-[14px] shrink-0" />
            <span class="truncate">{{ formatTimestamp(file.timestamp) }}</span>
          </span>
        </div>
      </div>
    </div>
  </button>
</template>

<script setup lang="ts">
import { Thumbnail } from '@dacr/library'
import { DacrMarkIcon } from '@dacr/icons'
import { type SearchFile } from '@/shared/graphql/legacy/generated'
import { fileThumbType, fileThumbSrc } from '@/features/search/utils'
import { formatTimestamp } from '@/shared/utils/datetime'

defineProps<{ file: SearchFile }>()

defineEmits<{ select: [] }>()
</script>
